export const geoValues = {
  OPR: {
    AFG: 'AFG ABC',
    AGO: 'AGO ABC',
    ALB: 'ALB ABC',
    ARG: 'ARG MC ABC',
    BOL: 'ARG MC ABC',
    CHL: 'ARG MC ABC',
    PRY: 'ARG MC ABC',
    URY: 'ARG MC ABC',
    ARM: 'ARM ABC',
    AUS: 'AUS MC ABC',
    COK: 'AUS MC ABC',
    FJI: 'AUS MC ABC',
    FSM: 'AUS MC ABC',
    KIR: 'AUS MC ABC',
    MHL: 'AUS MC ABC',
    NIU: 'AUS MC ABC',
    NRU: 'AUS MC ABC',
    NZL: 'AUS MC ABC',
    PLW: 'AUS MC ABC',
    PNG: 'AUS MC ABC',
    SLB: 'AUS MC ABC',
    TON: 'AUS MC ABC',
    TUV: 'AUS MC ABC',
    VUT: 'AUS MC ABC',
    WSM: 'AUS MC ABC',
    AZE: 'AZE ABC',
    BDI: 'BDI ABC',
    BEL: 'BEL MC ABC',
    IRL: 'BEL MC ABC',
    LUX: 'BEL MC ABC',
    NLD: 'BEL MC ABC',
    PRT: 'BEL MC ABC',
    BFA: 'BFA ABC',
    BGD: 'BGD ABC',
    BGR: 'BGR ABC',
    BIH: 'BIH ABC',
    BLR: 'BLR ABC',
    BRA: 'BRA ABC',
    CAF: 'CAF ABC',
    CAN: 'CAN ABC',
    CHN: 'CHN ABC',
    BEN: 'CIV MC ABC',
    CIV: 'CIV MC ABC',
    GHA: 'CIV MC ABC',
    LBR: 'CIV MC ABC',
    TGO: 'CIV MC ABC',
    CMR: 'CMR MC ABC',
    GAB: 'CMR MC ABC',
    COD: 'COD ABC',
    COG: 'COG ABC',
    COL: 'COL ABC',
    CRI: 'CRI ABC',
    CYP: 'CYP ABC',
    DEU: 'DEU ABC',
    DJI: 'DJI ABC',
    DZA: 'DZA ABC',
    ECU: 'ECU ABC',
    EGY: 'EGY ABC',
    ERI: 'ERI ABC',
    ESH: 'ESH ABC',
    ESP: 'ESP ABC',
    ETH: 'ETH ABC',
    FRA: 'FRA ABC',
    GBR: 'GBR ABC',
    GEO: 'GEO ABC',
    GRC: 'GRC ABC',
    GTM: 'GTM ABC',
    HND: 'HND ABC',
    HRV: 'HRV ABC',
    CZE: 'HUN MC ABC',
    HUN: 'HUN MC ABC',
    SVK: 'HUN MC ABC',
    SVN: 'HUN MC ABC',
    IDN: 'IDN ABC',
    IND: 'IND ABC',
    IRN: 'IRN ABC',
    IRQ: 'IRQ ABC',
    ISR: 'ISR ABC',
    ITA: 'ITA MC ABC',
    SMR: 'ITA MC ABC',
    VAT: 'ITA MC ABC',
    JOR: 'JOR ABC',
    JPN: 'JPN ABC',
    KAZ: 'KAZ MC ABC',
    KGZ: 'KAZ MC ABC',
    TJK: 'KAZ MC ABC',
    TKM: 'KAZ MC ABC',
    UZB: 'KAZ MC ABC',
    KEN: 'KEN ABC',
    KOR: 'KOR ABC',
    XKX: 'KOS ABC',
    LBN: 'LBN ABC',
    LBY: 'LBY ABC',
    LKA: 'LKA ABC',
    MAR: 'MAR ABC',
    MDA: 'MDA ABC',
    MEX: 'MEX ABC',
    MKD: 'MKD ABC',
    MLI: 'MLI ABC',
    MLT: 'MLT ABC',
    MMR: 'MMR ABC',
    MNE: 'MNE ABC',
    MOZ: 'MOZ ABC',
    MRT: 'MRT ABC',
    MWI: 'MWI ABC',
    MYS: 'MYS ABC',
    NER: 'NER ABC',
    NGA: 'NGA ABC',
    NPL: 'NPL ABC',
    AUT: 'OOE ABC',
    CHE: 'OOE ABC',
    LIE: 'OOE ABC',
    PAK: 'PAK ABC',
    BLZ: 'PAN MC ABC',
    CUB: 'PAN MC ABC',
    GUY: 'PAN MC ABC',
    NIC: 'PAN MC ABC',
    PAN: 'PAN MC ABC',
    SUR: 'PAN MC ABC',
    TTO: 'PAN MC ABC',
    ABW: 'PAN MC ABC',
    CUW: 'PAN MC ABC',
    PER: 'PER ABC',
    PHL: 'PHL ABC',
    POL: 'POL ABC',
    ROU: 'ROU ABC',
    RUS: 'RUS ABC',
    RWA: 'RWA ABC',
    ARE: 'SAU MC ABC',
    BHR: 'SAU MC ABC',
    KWT: 'SAU MC ABC',
    OMN: 'SAU MC ABC',
    QAT: 'SAU MC ABC',
    SAU: 'SAU MC ABC',
    SDN: 'SDN ABC',
    CPV: 'SEN MC ABC',
    GIN: 'SEN MC ABC',
    GMB: 'SEN MC ABC',
    GNB: 'SEN MC ABC',
    SEN: 'SEN MC ABC',
    SLE: 'SEN MC ABC',
    SLV: 'SLV ABC',
    SOM: 'SOM ABC',
    SRB: 'SRB ABC',
    SSD: 'SSD ABC',
    DNK: 'SWE MC ABC',
    EST: 'SWE MC ABC',
    FIN: 'SWE MC ABC',
    ISL: 'SWE MC ABC',
    LTU: 'SWE MC ABC',
    LVA: 'SWE MC ABC',
    NOR: 'SWE MC ABC',
    SWE: 'SWE MC ABC',
    SYR: 'SYR ABC',
    TCD: 'TCD ABC',
    KHM: 'THA MC ABC',
    LAO: 'THA MC ABC',
    THA: 'THA MC ABC',
    VNM: 'THA MC ABC',
    TUN: 'TUN ABC',
    TUR: 'TUR ABC',
    TZA: 'TZA ABC',
    UGA: 'UGA ABC',
    UKR: 'UKR ABC',
    ATG: 'USA MC ABC',
    BHS: 'USA MC ABC',
    BRB: 'USA MC ABC',
    DMA: 'USA MC ABC',
    DOM: 'USA MC ABC',
    GRD: 'USA MC ABC',
    HTI: 'USA MC ABC',
    JAM: 'USA MC ABC',
    KNA: 'USA MC ABC',
    LCA: 'USA MC ABC',
    USA: 'USA MC ABC',
    VCT: 'USA MC ABC',
    AIA: 'USA MC ABC',
    BES: 'USA MC ABC',
    BMU: 'USA MC ABC',
    CYM: 'USA MC ABC',
    MSR: 'USA MC ABC',
    SXM: 'USA MC ABC',
    TCA: 'USA MC ABC',
    VGB: 'USA MC ABC',
    VEN: 'VEN ABC',
    YEM: 'YEM ABC',
    BWA: 'ZAF MC ABC',
    COM: 'ZAF MC ABC',
    LSO: 'ZAF MC ABC',
    MDG: 'ZAF MC ABC',
    MUS: 'ZAF MC ABC',
    NAM: 'ZAF MC ABC',
    SWZ: 'ZAF MC ABC',
    SYC: 'ZAF MC ABC',
    ZAF: 'ZAF MC ABC',
    ZMB: 'ZMB ABC',
    ZWE: 'ZWE ABC',
  },
  REG: {
    ARG: 'RBA',
    BOL: 'RBA',
    CHL: 'RBA',
    PRY: 'RBA',
    URY: 'RBA',
    BRA: 'RBA',
    CAN: 'RBA',
    COL: 'RBA',
    CRI: 'RBA',
    ECU: 'RBA',
    GTM: 'RBA',
    HND: 'RBA',
    MEX: 'RBA',
    BLZ: 'RBA',
    CUB: 'RBA',
    GUY: 'RBA',
    NIC: 'RBA',
    PAN: 'RBA',
    SUR: 'RBA',
    TTO: 'RBA',
    PER: 'RBA',
    SLV: 'RBA',
    ATG: 'RBA',
    BHS: 'RBA',
    BRB: 'RBA',
    DMA: 'RBA',
    DOM: 'RBA',
    GRD: 'RBA',
    HTI: 'RBA',
    JAM: 'RBA',
    KNA: 'RBA',
    LCA: 'RBA',
    USA: 'RBA',
    VCT: 'RBA',
    VEN: 'RBA',
    AFG: 'RBAP',
    AUS: 'RBAP',
    COK: 'RBAP',
    FJI: 'RBAP',
    FSM: 'RBAP',
    KIR: 'RBAP',
    MHL: 'RBAP',
    NIU: 'RBAP',
    NRU: 'RBAP',
    NZL: 'RBAP',
    PLW: 'RBAP',
    PNG: 'RBAP',
    SLB: 'RBAP',
    TON: 'RBAP',
    TUV: 'RBAP',
    VUT: 'RBAP',
    WSM: 'RBAP',
    BGD: 'RBAP',
    CHN: 'RBAP',
    IDN: 'RBAP',
    IND: 'RBAP',
    IRN: 'RBAP',
    JPN: 'RBAP',
    KAZ: 'RBAP',
    KGZ: 'RBAP',
    TJK: 'RBAP',
    TKM: 'RBAP',
    UZB: 'RBAP',
    KOR: 'RBAP',
    LKA: 'RBAP',
    MMR: 'RBAP',
    MYS: 'RBAP',
    NPL: 'RBAP',
    PAK: 'RBAP',
    PHL: 'RBAP',
    KHM: 'RBAP',
    LAO: 'RBAP',
    THA: 'RBAP',
    VNM: 'RBAP',
    ALB: 'RBE',
    ARM: 'RBE',
    AZE: 'RBE',
    BEL: 'RBE',
    IRL: 'RBE',
    LUX: 'RBE',
    NLD: 'RBE',
    PRT: 'RBE',
    BGR: 'RBE',
    BIH: 'RBE',
    BLR: 'RBE',
    CYP: 'RBE',
    DEU: 'RBE',
    ESP: 'RBE',
    FRA: 'RBE',
    GBR: 'RBE',
    GEO: 'RBE',
    GRC: 'RBE',
    HRV: 'RBE',
    CZE: 'RBE',
    HUN: 'RBE',
    SVK: 'RBE',
    SVN: 'RBE',
    ITA: 'RBE',
    SMR: 'RBE',
    VAT: 'RBE',
    MDA: 'RBE',
    MKD: 'RBE',
    MLT: 'RBE',
    MNE: 'RBE',
    AUT: 'RBE',
    CHE: 'RBE',
    LIE: 'RBE',
    ABW: 'RBE',
    CUW: 'RBE',
    POL: 'RBE',
    ROU: 'RBE',
    RUS: 'RBE',
    SRB: 'RBE',
    DNK: 'RBE',
    EST: 'RBE',
    FIN: 'RBE',
    ISL: 'RBE',
    LTU: 'RBE',
    LVA: 'RBE',
    NOR: 'RBE',
    SWE: 'RBE',
    TUR: 'RBE',
    UKR: 'RBE',
    AIA: 'RBE',
    BES: 'RBE',
    BMU: 'RBE',
    CYM: 'RBE',
    MSR: 'RBE',
    SXM: 'RBE',
    TCA: 'RBE',
    VGB: 'RBE',
    BDI: 'RBEHAGL',
    DJI: 'RBEHAGL',
    ERI: 'RBEHAGL',
    ETH: 'RBEHAGL',
    KEN: 'RBEHAGL',
    RWA: 'RBEHAGL',
    SDN: 'RBEHAGL',
    SOM: 'RBEHAGL',
    SSD: 'RBEHAGL',
    TZA: 'RBEHAGL',
    UGA: 'RBEHAGL',
    DZA: 'RBMENA',
    EGY: 'RBMENA',
    ESH: 'RBMENA',
    IRQ: 'RBMENA',
    ISR: 'RBMENA',
    JOR: 'RBMENA',
    LBN: 'RBMENA',
    LBY: 'RBMENA',
    MAR: 'RBMENA',
    MRT: 'RBMENA',
    ARE: 'RBMENA',
    BHR: 'RBMENA',
    KWT: 'RBMENA',
    OMN: 'RBMENA',
    QAT: 'RBMENA',
    SAU: 'RBMENA',
    SYR: 'RBMENA',
    TUN: 'RBMENA',
    YEM: 'RBMENA',
    AGO: 'RBSA',
    COD: 'RBSA',
    COG: 'RBSA',
    MOZ: 'RBSA',
    MWI: 'RBSA',
    BWA: 'RBSA',
    COM: 'RBSA',
    LSO: 'RBSA',
    MDG: 'RBSA',
    MUS: 'RBSA',
    NAM: 'RBSA',
    SWZ: 'RBSA',
    SYC: 'RBSA',
    ZAF: 'RBSA',
    ZMB: 'RBSA',
    ZWE: 'RBSA',
    BFA: 'RBWCA',
    CAF: 'RBWCA',
    BEN: 'RBWCA',
    CIV: 'RBWCA',
    GHA: 'RBWCA',
    LBR: 'RBWCA',
    TGO: 'RBWCA',
    CMR: 'RBWCA',
    GAB: 'RBWCA',
    MLI: 'RBWCA',
    NER: 'RBWCA',
    NGA: 'RBWCA',
    CPV: 'RBWCA',
    GIN: 'RBWCA',
    GMB: 'RBWCA',
    GNB: 'RBWCA',
    SEN: 'RBWCA',
    SLE: 'RBWCA',
    TCD: 'RBWCA',
  },
  CTY: {
    ABW: 'ABW',
    AFG: 'AFG',
    AGO: 'AGO',
    AIA: 'AIA',
    ALB: 'ALB',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ATG: 'ATG',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BES: 'BES',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHR: 'BHR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BMU: 'BMU',
    BOL: 'BOL',
    BRA: 'BRA',
    BRB: 'BRB',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COK: 'COK',
    COL: 'COL',
    COM: 'COM',
    CPV: 'CPV',
    CRI: 'CRI',
    CUB: 'CUB',
    CUW: 'CUW',
    CYM: 'CYM',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DMA: 'DMA',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESH: 'ESH',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FRA: 'FRA',
    FSM: 'FSM',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GHA: 'GHA',
    GIN: 'GIN',
    GMB: 'GMB',
    GNB: 'GNB',
    GRC: 'GRC',
    GRD: 'GRD',
    GTM: 'GTM',
    GUY: 'GUY',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IND: 'IND',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KIR: 'KIR',
    KNA: 'KNA',
    KOR: 'KOR',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LCA: 'LCA',
    LIE: 'LIE',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAR: 'MAR',
    MDA: 'MDA',
    MDG: 'MDG',
    MEX: 'MEX',
    MHL: 'MHL',
    MKD: 'MKD',
    MLI: 'MLI',
    MLT: 'MLT',
    MMR: 'MMR',
    MNE: 'MNE',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MSR: 'MSR',
    MUS: 'MUS',
    MWI: 'MWI',
    MYS: 'MYS',
    NAM: 'NAM',
    NER: 'NER',
    NGA: 'NGA',
    NIC: 'NIC',
    NIU: 'NIU',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NRU: 'NRU',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PER: 'PER',
    PHL: 'PHL',
    PLW: 'PLW',
    PNG: 'PNG',
    POL: 'POL',
    PRT: 'PRT',
    PRY: 'PRY',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    SAU: 'SAU',
    SDN: 'SDN',
    SEN: 'SEN',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SMR: 'SMR',
    SOM: 'SOM',
    SRB: 'SRB',
    SSD: 'SSD',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SXM: 'SXM',
    SYC: 'SYC',
    SYR: 'SYR',
    TCA: 'TCA',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKM: 'TKM',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TUV: 'TUV',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VAT: 'VAT',
    VCT: 'VCT',
    VEN: 'VEN',
    VGB: 'VGB',
    VNM: 'VNM',
    VUT: 'VUT',
    WSM: 'WSM',
    XKX: 'XKX',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE',
  },
  GLB: {
    XKX: 'GLB',
    ARG: 'GLB',
    BOL: 'GLB',
    CHL: 'GLB',
    PRY: 'GLB',
    URY: 'GLB',
    BRA: 'GLB',
    CAN: 'GLB',
    COL: 'GLB',
    CRI: 'GLB',
    ECU: 'GLB',
    GTM: 'GLB',
    HND: 'GLB',
    MEX: 'GLB',
    BLZ: 'GLB',
    CUB: 'GLB',
    GUY: 'GLB',
    NIC: 'GLB',
    PAN: 'GLB',
    SUR: 'GLB',
    TTO: 'GLB',
    PER: 'GLB',
    SLV: 'GLB',
    ATG: 'GLB',
    BHS: 'GLB',
    BRB: 'GLB',
    DMA: 'GLB',
    DOM: 'GLB',
    GRD: 'GLB',
    HTI: 'GLB',
    JAM: 'GLB',
    KNA: 'GLB',
    LCA: 'GLB',
    USA: 'GLB',
    VCT: 'GLB',
    VEN: 'GLB',
    AFG: 'GLB',
    AUS: 'GLB',
    COK: 'GLB',
    FJI: 'GLB',
    FSM: 'GLB',
    KIR: 'GLB',
    MHL: 'GLB',
    NIU: 'GLB',
    NRU: 'GLB',
    NZL: 'GLB',
    PLW: 'GLB',
    PNG: 'GLB',
    SLB: 'GLB',
    TON: 'GLB',
    TUV: 'GLB',
    VUT: 'GLB',
    WSM: 'GLB',
    BGD: 'GLB',
    CHN: 'GLB',
    IDN: 'GLB',
    IND: 'GLB',
    IRN: 'GLB',
    JPN: 'GLB',
    KAZ: 'GLB',
    KGZ: 'GLB',
    TJK: 'GLB',
    TKM: 'GLB',
    UZB: 'GLB',
    KOR: 'GLB',
    LKA: 'GLB',
    MMR: 'GLB',
    MYS: 'GLB',
    NPL: 'GLB',
    PAK: 'GLB',
    PHL: 'GLB',
    KHM: 'GLB',
    LAO: 'GLB',
    THA: 'GLB',
    VNM: 'GLB',
    ALB: 'GLB',
    ARM: 'GLB',
    AZE: 'GLB',
    BEL: 'GLB',
    IRL: 'GLB',
    LUX: 'GLB',
    NLD: 'GLB',
    PRT: 'GLB',
    BGR: 'GLB',
    BIH: 'GLB',
    BLR: 'GLB',
    CYP: 'GLB',
    DEU: 'GLB',
    ESP: 'GLB',
    FRA: 'GLB',
    GBR: 'GLB',
    GEO: 'GLB',
    GRC: 'GLB',
    HRV: 'GLB',
    CZE: 'GLB',
    HUN: 'GLB',
    SVK: 'GLB',
    SVN: 'GLB',
    ITA: 'GLB',
    SMR: 'GLB',
    VAT: 'GLB',
    MDA: 'GLB',
    MKD: 'GLB',
    MLT: 'GLB',
    MNE: 'GLB',
    AUT: 'GLB',
    CHE: 'GLB',
    LIE: 'GLB',
    ABW: 'GLB',
    CUW: 'GLB',
    POL: 'GLB',
    ROU: 'GLB',
    RUS: 'GLB',
    SRB: 'GLB',
    DNK: 'GLB',
    EST: 'GLB',
    FIN: 'GLB',
    ISL: 'GLB',
    LTU: 'GLB',
    LVA: 'GLB',
    NOR: 'GLB',
    SWE: 'GLB',
    TUR: 'GLB',
    UKR: 'GLB',
    AIA: 'GLB',
    BES: 'GLB',
    BMU: 'GLB',
    CYM: 'GLB',
    MSR: 'GLB',
    SXM: 'GLB',
    TCA: 'GLB',
    VGB: 'GLB',
    BDI: 'GLB',
    DJI: 'GLB',
    ERI: 'GLB',
    ETH: 'GLB',
    KEN: 'GLB',
    RWA: 'GLB',
    SDN: 'GLB',
    SOM: 'GLB',
    SSD: 'GLB',
    TZA: 'GLB',
    UGA: 'GLB',
    DZA: 'GLB',
    EGY: 'GLB',
    ESH: 'GLB',
    IRQ: 'GLB',
    ISR: 'GLB',
    JOR: 'GLB',
    LBN: 'GLB',
    LBY: 'GLB',
    MAR: 'GLB',
    MRT: 'GLB',
    ARE: 'GLB',
    BHR: 'GLB',
    KWT: 'GLB',
    OMN: 'GLB',
    QAT: 'GLB',
    SAU: 'GLB',
    SYR: 'GLB',
    TUN: 'GLB',
    YEM: 'GLB',
    AGO: 'GLB',
    COD: 'GLB',
    COG: 'GLB',
    MOZ: 'GLB',
    MWI: 'GLB',
    BWA: 'GLB',
    COM: 'GLB',
    LSO: 'GLB',
    MDG: 'GLB',
    MUS: 'GLB',
    NAM: 'GLB',
    SWZ: 'GLB',
    SYC: 'GLB',
    ZAF: 'GLB',
    ZMB: 'GLB',
    ZWE: 'GLB',
    BFA: 'GLB',
    CAF: 'GLB',
    BEN: 'GLB',
    CIV: 'GLB',
    GHA: 'GLB',
    LBR: 'GLB',
    TGO: 'GLB',
    CMR: 'GLB',
    GAB: 'GLB',
    MLI: 'GLB',
    NER: 'GLB',
    NGA: 'GLB',
    CPV: 'GLB',
    GIN: 'GLB',
    GMB: 'GLB',
    GNB: 'GLB',
    SEN: 'GLB',
    SLE: 'GLB',
    TCD: 'GLB',
  },
};
